import { render, staticRenderFns } from "./GinIndex.vue?vue&type=template&id=10abc237"
import script from "./GinIndex.vue?vue&type=script&lang=js"
export * from "./GinIndex.vue?vue&type=script&lang=js"
import style0 from "./GinIndex.vue?vue&type=style&index=0&id=10abc237&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports